import React from 'react';
import Grid from '@material-ui/core/Grid';
import Logo from './Logo';
import Introduction from './Introduction';
import MWMLogo from '../img/mwm-LOGO-v1.png';
import SPPLogo from '../img/SPP_LOGO.png';

export default function Header() {
  return (
    <div>
      <Grid container alignItems='center' justify='space-between'>
        <Grid item={true} xs={12} sm={4}>
          <Logo 
            src={MWMLogo} 
            alt={"Measure What Matters Logo"} 
            height={100} 
            align={'left'}
          />
        </Grid>
        <Grid item={true} xs={12} sm={4}>
          <Logo 
            src={SPPLogo} 
            alt={"School of Public Policy Logo"} 
            height={60}
            align={'right'}
          />
        </Grid>
      </Grid>
      <br />
      <Introduction />
    </div>
  );
}
